import React, { useState } from "react";
import PaymentButton from "../PaymentButton";
import BankAccountInfo from "./BankAccountInfo";
import { getSaju } from "../../framework/api";
import { useLocation } from "react-router-dom";
import { formatBirthDate, formatTime } from "../../utils/timeConvert";

interface Step3BankTransferProps {
  value: string; // accountInfo
  onChange: (val: string) => void;
  onNext: (accountInfo: string) => void;
  onBack: () => void;
  paymentData: {
    phoneNumber: string;
    paymentMethod: "card" | "bank";
    email?: string;
    accountInfo?: string;
  };
  fortuneData: {
    name: string;
    birth: string;
    time: string;
    leap: string;
    gender: string;
    question: string;
  };
}
// 입금자명 입력 검증 필수
function Step3BankTransfer({
  value,
  onChange,
  onNext,
  onBack,
  paymentData,
  fortuneData,
}: Step3BankTransferProps) {
  const location = useLocation();
  const [depositCompleted, setDepositCompleted] = useState(false);
  const isVideoRoute = location.pathname.includes("/video");
  const handleConfirm = async () => {
    if (!value.trim()) {
      alert("입금자명을 입력해주세요.");
      return;
    }
    if (!depositCompleted) {
      alert("입금 완료를 확인해주세요.");
      return;
    }
    // 입금완료전 데이터 전송
    console.log("paymentData::", paymentData);
    console.log("value::", value);
    // 두개 합친정보
    const combinedInfo = {
      ...paymentData,
      ...fortuneData,
    };
    console.log("combinedInfo::", combinedInfo);

    console.log("post payment info::", {
      productType: isVideoRoute ? "video" : "phone",
      paymentType: "bank",
      // 먼저 숫자만 남기고 문자열 제거, 그 후 0000-00-00 형식으로 변경
      // ex)1997/01/25 -> 19970125 -> 1997-01-25
      name: fortuneData.name,
      birthday: formatBirthDate(fortuneData.birth),
      birthdayType: fortuneData.leap.toUpperCase(),
      gender: fortuneData.gender.toUpperCase(),
      // 10:00 형식으로 변경, 단 time이 "????" 해당 문자열일 경우 "20:30"으로 변경
      time: formatTime(fortuneData.time),
      phone: paymentData.phoneNumber.replace(/[^0-9]/g, ""),
      question: fortuneData.question,

      email: paymentData.email || "",
      depositorName: paymentData.accountInfo,
    });
    // return;
    //productType이 phone인 경우 이메일 파라미터 없애고 전달해야함.

    const postData = {
      productType: isVideoRoute ? "video" : "phone",
      paymentType: "bank",
      // 먼저 숫자만 남기고 문자열 제거, 그 후 0000-00-00 형식으로 변경
      // ex)1997/01/25 -> 19970125 -> 1997-01-25
      name: fortuneData.name,
      birthday: formatBirthDate(fortuneData.birth),
      birthdayType: fortuneData.leap.toUpperCase(),
      gender: fortuneData.gender.toUpperCase(),
      // 10:00 형식으로 변경, 단 time이 "????" 해당 문자열일 경우 "20:30"으로 변경
      time: formatTime(fortuneData.time),
      phone: paymentData.phoneNumber.replace(/[^0-9]/g, ""),
      question: fortuneData.question,

      ...(isVideoRoute ? { email: paymentData.email || "" } : {}),
      depositorName: paymentData.accountInfo,
    };

    console.log("postData::", postData);

    await getSaju.post("/mobile/payment", postData);
    onNext(value);
  };

  return (
    <main className="flex flex-col items-center bg-[#F9F9FC] relative">
      <button
        className="absolute -top-4 left-4 text-[#222] text-base"
        onClick={onBack}
      >
        뒤로가기
      </button>
      <h2 className="text-2xl font-bold mb-8">계좌이체하기</h2>

      <div className="w-full max-w-[320px] flex flex-col gap-8 items-center mx-auto">
        {/* 계좌 정보 표시 */}
        <BankAccountInfo />

        {/* 안내문구 */}
        <div className="text-center text-base text-[#222] mb-2">
          입금확인이 된 이후에,
          <br />
          사주 전화 상담이 이루어집니다.
        </div>

        {/* 입금자 정보 입력 */}
        <div className="flex items-center gap-1 w-full">
          <label className="text-base font-semibold mb-1">입금자명:</label>
          <input
            maxLength={20}
            type="text"
            name="accountInfo"
            placeholder="입금자명을 입력해주세요"
            className="h-[40px] border border-[#D1C4E9] rounded-lg px-4 text-lg bg-white focus:outline-[#9D7FDE] placeholder:text-[#BDBDBD]"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>

        {/* 입금 완료 체크박스 */}
        <div className="flex items-center justify-center gap-2 w-full mt-2">
          <input
            type="checkbox"
            id="depositCompleted"
            checked={depositCompleted}
            onChange={(e) => setDepositCompleted(e.target.checked)}
            className="w-5 h-5 accent-[#9D7FDE] border-gray-300 rounded focus:ring-[#9D7FDE]"
          />
          <label
            htmlFor="depositCompleted"
            className="text-base text-[#222] select-none"
          >
            입금 완료하였습니다.
          </label>
        </div>

        {/* 확인 버튼 */}
        <PaymentButton
          className="bg-[#9D7FDE] text-white text-xl mt-8 shadow-none hover:brightness-95 h-[48px] !rounded-lg w-full max-w-[400px]"
          onClick={handleConfirm}
        >
          확인
        </PaymentButton>
      </div>
    </main>
  );
}

export default Step3BankTransfer;
